export enum BenefitType {
    None = 0,
    ExtendedHealth = 1,
    Vision = 2,
    Dental = 3,
    HSA = 4,
    WSA = 5
}